import { useRef, useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { Preset } from '../types';
import { presetApi } from '../api';
import { presetKeys } from './preset.keys';

export function usePreset(
  id?: string,
  options?: Omit<UseQueryOptions<Preset, Error>, 'queryKey' | 'queryFn'>
) {
  const queryKey = id ? presetKeys.detail(id) : [...presetKeys.details(), ''];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!id) throw new Error('ID do preset não informado');
      return presetApi.get(id, signal);
    },
    enabled: Boolean(id),
    ...(options as Omit<UseQueryOptions<Preset, Error>, 'queryKey' | 'queryFn'>),
  });

  const lastErrorRef = useRef<Error | null>(null);
  useEffect(() => {
    if (!query.error) {
      lastErrorRef.current = null;
      return;
    }
    if (lastErrorRef.current === query.error) return;
    lastErrorRef.current = query.error;
    toast({
      title: 'Erro ao carregar preset',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    preset: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
